import {isDate} from '@/utils/datetime'
import { infoRender } from './utils'

export const ctrlMixin = {
    data: function () {
        return {
          loading: false,
          locks: [],
        }
    },
    mounted() {
        // 自动查询
        if(this.config.autoquery!=false && this.config.id && this.$refs["searcher"]) {
            this.$refs["searcher"].submit()
        }
    },
    computed: {
        queryId() {
            return this.$route.query.id?this.$route.query.id:this.config.id
        },
        marks() {
            return this.$store.getters.getMarks(parseInt(this.$route.query.id))
        },
        mark_permission() {
            return this.$store.state.game.info.mark
        },
        config() {
            return this.$store.state.config.page
        },
        modules() {
            return this.$store.state.config.page.modules?this.$store.state.config.page.modules:[]
        }
    },
    watch: {
        config() {
            // 自动查询
            if(this.config.autoquery!=false && this.config.id) {
                this.$refs["searcher"].submit()
            }
        },
        loading(newV) {
            if(!newV) {
                this.$store.commit('set_query', 0)
            }
            else {
                if(this.config.fuxi) {
                    this.$store.commit('set_query', 2)
                }
                else {
                    this.$store.commit('set_query', 1)
                }
            }
        },
    },
    methods: {
        // 获取统计
        getInfo(modInfo, dataInfo, datas) {
            return infoRender(modInfo, dataInfo, datas)
        },
        //下载
        exportToExcel(index, tb) {
            let table = `datatable_${index}`
            let filename = this.modules&&this.modules[index]&&this.modules[index].name?this.modules[index].name:this.config.name
            if(tb) {
                table = `${table}_${tb}`
                filename = `${filename}${tb==1?'投放':'回收'}`
            }
            if(this.$refs[table] instanceof Array) {
                this.$refs[table][0].exportToExcel(filename)
            }
            else {
                this.$refs[table].exportToExcel(filename)
            }
        },
        //复制
        copy(index, tb) {
            let table = `datatable_${index}`
            if(tb) {
                table = `${table}_${tb}`
            }
            if(this.$refs[table] instanceof Array) {
                this.$refs[table][0].copy()
            }
            else {
                this.$refs[table].copy()
            }
        },
        lockHeader(index, tb) {
            let lock = false
            let table = `datatable_${index}`
            if(tb) {
                table = `${table}_${tb}`
            }
            let lock_index = this.locks.indexOf(tb?`${index}_${tb}`:index)
            if(lock_index>=0) {
                lock = true
                this.locks.splice(lock_index,1)
            }
            else {
                this.locks.push(tb?`${index}_${tb}`:index)
            }
            if(this.$refs[table] instanceof Array) {
                this.$refs[table][0].lockHeader(!lock)
            }
            else {
                this.$refs[table].lockHeader(!lock)
            }
        },
        isMark(datas, fields) {
            if(datas.length === 0) {
                return false
            } else { 
                if((_.map(fields, 'title')).indexOf('日期')!=-1) {
                    const key = _.find(fields, {'title': '日期'})['id']
                    if(isDate(datas[0][key], false)) {
                        const dates = _.map(datas, key)
                        let days = dates.sort().map((d, i) => {
                            let dt = new Date(d)
                            dt.setDate(dt.getDate() + 4 - i)
                            return +dt
                        })
                        return [...new Set(days)].length === 1 ? true : false
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            }
        }
    }
}